import React, { useState, useRef, useEffect } from 'react';
import {
  useGetProfileCategoriesQuery,
  useLazyGetProfileInformationQuery,
  useUpdateProfileInformationMutation,
  useUnlinkGoogleClassroomMutation
} from '../../features/componentEndpoints/profileInformationEndpoints';
import PropTypes from 'prop-types';
import {
  faUpload,
  faCircleCheck,
  faCircleXmark,
  faEye,
  faEyeSlash,
  faCircle,
  faTrashAlt
} from '@fortawesome/pro-solid-svg-icons';
import { faCircleInfo } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Accordion, Button, Row } from 'react-bootstrap';
import './myProfile.scss';
import UserPositionDetailsPage from '../profileInfoModal/userCategoryDetails';
import { useNavigate } from 'react-router';
import CustomToast from '../../../src/components/Toast';
import ImageUpload from '../../components/ImageUpload';
import SkeletonGrid from '../../components/SkeletonLoader/SkeletonGrid';
import Skeleton from 'react-loading-skeleton';

export function DisplayCourses(props) {
  var displayCourses = [];
  var courses = [];
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [checkboxData, setCheckboxData] = useState({});
  const [isFirstElementCheck, setIsFirstElementCheck] = useState(false);
  const [resultArray, setResultArray] = useState([]);

  const {
    profileCategoriesData: { displayCourses: courseData }
  } = props;
  let persistApi = [];
  let temporaryResultArray = [];

  const persistIterations = (primary) => {
    let isAllPersistChecked = true;
    let subCoursesDataArray = [];
    let persistDataIds = [];
    primary.subCoursesData.forEach((obj) => {
      if (props.profileData?.includes(obj.categoryId)) persistDataIds.push(obj.categoryId);
    });
    primary.subCoursesData.forEach((subCourse, index) => {
      if (persistDataIds.includes(subCourse.categoryId)) {
        subCoursesDataArray.push({ ...subCourse, isChecked: true });
      } else {
        if (primary.categoryId !== -1) {
          if (index !== 0) isAllPersistChecked = false;
        } else {
          isAllPersistChecked = false;
        }
        subCoursesDataArray.push({ ...subCourse, isChecked: false });
      }
    });
    persistApi.push({
      ...primary,
      isChecked: isAllPersistChecked,
      subCoursesData: subCoursesDataArray
    });
  };

  useEffect(() => {
    if (courseData) {
      let mappedData = courseData.reduce((result, { primaryCourse, subCourses }, key) => {
        const { categoryId, categoryOption } = primaryCourse;
        if (categoryId !== -1) {
          const subCoursesData = [
            {
              categoryId: parseInt(categoryId),
              categoryOption: categoryOption,
              primaryCourseId: categoryId,
              isChecked: false
            },
            ...subCourses.map((subcourse) => ({
              ...subcourse,
              primaryCourseId: categoryId,
              isChecked: false
            }))
          ];
          result[categoryId] = { categoryId, categoryOption, isChecked: false, subCoursesData };
        } else {
          const subCoursesData = [
            ...subCourses.map((subcourse) => ({
              ...subcourse,
              primaryCourseId: categoryId,
              isChecked: false
            }))
          ];
          result[categoryId] = { categoryId, categoryOption, isChecked: false, subCoursesData };
        }
        return result;
      }, []);

      const primaryCourseIdArray = Object.values(mappedData).map((data) => {
        return data.categoryId;
      });

      props.profileData?.forEach((persistIds) => {
        Object.values(mappedData).forEach((primary) => {
          if (persistIds === primary.categoryId) {
            persistIterations(primary);
          } else if (primaryCourseIdArray.includes(primary.categoryId)) {
            persistIterations(primary);
          }
        });
      });

      const mappedObj = {};
      persistApi.forEach((data) => {
        if (!mappedObj[data.categoryId]) mappedObj[data.categoryId] = data;
      });

      let checkVals;
      if (props.profileData?.length > 0) {
        checkVals = Object.values(mappedObj);
      } else {
        checkVals = Object.values(mappedData);
      }
      if (checkVals.every(({ isChecked }) => isChecked)) {
        if (!isFirstElementCheck) setIsFirstElementCheck(true);
        setIsAllChecked(true);
      } else setIsAllChecked(false);
      if (props.profileData?.length > 0) {
        setCheckboxData(mappedObj);
      } else {
        setCheckboxData(mappedData);
      }
    }
    setResultArray(props.profileData);
  }, [courseData, props.profileData]);

  const handleProfileCategoriesChange = ({ target: { id, checked, name } }) => {
    const categoryId = parseInt(id.split('displayCourse_')[1]);
    const checkboxTemp = { ...checkboxData };
    if (id === 'displayCourse_all') {
      Object.keys(checkboxTemp).forEach((key) => {
        const c = checkboxTemp[key];
        c.isChecked = checked;
        c.subCoursesData = c.subCoursesData.map((d) => ({ ...d, isChecked: checked }));
        checkboxTemp[key] = c;
      });

      if (checked) {
        if (!isFirstElementCheck) setIsFirstElementCheck(true);
      }
      let profileDataChecked = [];

      Object.values(checkboxTemp).forEach((primary) => {
        if (checked) {
          primary.categoryId !== -1 ? profileDataChecked.push(primary.categoryId) : '';
          primary.subCoursesData.forEach((subcourse, index) => {
            if (subcourse.primaryCourseId !== -1) {
              profileDataChecked.push(subcourse.categoryId);
            } else {
              profileDataChecked.push(subcourse.categoryId);
            }
          });
        }
      });

      setIsAllChecked(checked);
      temporaryResultArray = profileDataChecked;
      setResultArray(profileDataChecked);
    } else {
      const course = checkboxTemp[name];
      if (name + '' === categoryId + '') {
        if (!isFirstElementCheck) {
          setIsFirstElementCheck(true);
        }
        let profileDataChecked = [];
        profileDataChecked = [...resultArray];
        if (checked) {
          if (id.split('displayCourse_')[0] == 'primary') {
            course.subCoursesData?.map((course) =>
              !resultArray.includes(course.categoryId) && course.primaryCourseId === categoryId
                ? profileDataChecked.push(course.categoryId)
                : ''
            );
          } else {
            !resultArray.includes(categoryId) ? profileDataChecked.push(categoryId) : '';
          }
        } else {
          let subCourseIds = course.subCoursesData?.map((item, index) => {
            if (item.primaryCourseId !== -1) {
              var dCoursePrefix = id.split('displayCourse_')[0];
              if (dCoursePrefix == 'primary' && index == 0) {
              } else return item.categoryId;
            } else {
              return item.categoryId;
            }
          });
          profileDataChecked = resultArray.filter((item) => !subCourseIds.includes(item));
        }
        temporaryResultArray = profileDataChecked;
        setResultArray(profileDataChecked);
        course.isChecked = checked;
        course.subCoursesData = course.subCoursesData?.map((course) => ({
          ...course,
          isChecked: checked
        }));
      } else {
        course.subCoursesData = course.subCoursesData?.map((course, key) => {
          const firstElement = course.categoryId;
          if (firstElement + '' === categoryId + '' && key === 0) {
            let primaryCourseId;
            if (course.primaryCourseId !== -1) {
              primaryCourseId = Math.floor(
                parseInt(firstElement) / Math.pow(10, (key + '').length)
              );
            } else {
              primaryCourseId = firstElement;
            }
            let profileDataChecked = [];
            profileDataChecked = [...resultArray];
            if (checked) {
              if (firstElement === primaryCourseId) {
                setIsFirstElementCheck(true);
              }
              !resultArray.includes(primaryCourseId)
                ? profileDataChecked.push(primaryCourseId)
                : '';
            } else {
              if (firstElement === primaryCourseId) {
                setIsFirstElementCheck(false);
              }
              profileDataChecked = profileDataChecked.filter((item) => item !== primaryCourseId);
            }
            temporaryResultArray = profileDataChecked;
            setResultArray(profileDataChecked);
          } else if (course.categoryId === categoryId) {
            let profileDataChecked = [];
            if (!isFirstElementCheck) setIsFirstElementCheck(true);
            profileDataChecked = [...resultArray];
            if (checked) {
              !resultArray.includes(course.primaryCourseId)
                ? course.primaryCourseId !== -1
                  ? profileDataChecked.push(course.primaryCourseId)
                  : ''
                : '';
              !resultArray.includes(categoryId) ? profileDataChecked.push(categoryId) : '';
            } else {
              profileDataChecked = profileDataChecked.filter((item) => item !== categoryId);
            }
            temporaryResultArray = profileDataChecked;
            setResultArray(profileDataChecked);
          }
          return course.categoryId === categoryId || firstElement + '' === categoryId + ''
            ? { ...course, isChecked: checked }
            : { ...course, isChecked: false };
        });
        if (course.subCoursesData?.every(({ isChecked }) => isChecked)) {
          course.isChecked = true;
        } else course.isChecked = false;
      }
      const checkVals = Object.values(checkboxTemp);
      if (checkVals.every(({ isChecked }) => isChecked)) {
        if (!isFirstElementCheck) setIsFirstElementCheck(true);
        setIsAllChecked(true);
      } else setIsAllChecked(false);
      checkboxTemp[name] = course;
    }

    setCheckboxData(checkboxTemp);
    let sortedArray = [];
    Object.values(checkboxTemp).forEach((primary) => {
      primary.categoryId !== -1 ? sortedArray.push(primary.categoryId) : '';
      primary.subCoursesData.forEach((subCourse, key) => {
        if (primary.categoryId !== -1) {
          sortedArray.push(subCourse.categoryId);
        } else {
          sortedArray.push(subCourse.categoryId);
        }
      });
    });

    let finalArray = [];
    sortedArray.forEach((courseId) => {
      if (temporaryResultArray.includes(courseId)) finalArray.push(courseId);
    });
    props.setDisplayCourseCategories(finalArray);
  };

  Object.keys(checkboxData).forEach((primaryCourseId, index) => {
    const courseCheckboxes = [];
    const { subCoursesData, categoryOption, isChecked } = checkboxData[primaryCourseId];
    courseCheckboxes.push(
      <Form.Check
        type="checkbox"
        id={'primarydisplayCourse_' + primaryCourseId}
        name={primaryCourseId}
        key={`${categoryOption}_${index}`}
        checked={isChecked}
        onChange={handleProfileCategoriesChange}
        style={{ marginBottom: '20px', fontSize: '14px', fontWeight: '400' }}
        label={categoryOption}
      />
    );
    courseCheckboxes.push(
      <div
        key={`${categoryOption}horizontalLine`}
        style={{ border: '1px solid #E7EDFF', width: '100%', marginBottom: '20px' }}
      />
    );
    subCoursesData.forEach((subCourse, key) => {
      courseCheckboxes.push(
        <Form.Check
          type="checkbox"
          id={'displayCourse_' + subCourse.categoryId}
          name={primaryCourseId}
          key={subCourse.categoryOption + '_' + subCourse.categoryId}
          checked={subCourse.isChecked}
          onChange={handleProfileCategoriesChange}
          style={{ marginBottom: '20px', fontSize: '14px', fontWeight: '400' }}
          label={subCourse.categoryOption}
          disabled={
            key === 0 &&
            subCourse.primaryCourseId !== -1 &&
            subCoursesData.slice(1).some((element) => element.isChecked || isChecked)
          }
          readOnly
        />
      );
    });
    courses.push(
      <div
        key={'course' + primaryCourseId}
        className="w-100 mx-3"
        style={{
          background: '#E7EDFF4d',
          borderRadius: '12px',
          padding: '30px',
          maxWidth: '625px'
        }}>
        {courseCheckboxes}
      </div>
    );
  });

  displayCourses.push(
    <div>
      <Form.Check
        type="checkbox"
        id={'displayCourse_all'}
        checked={isAllChecked}
        onChange={handleProfileCategoriesChange}
        style={{ marginBottom: '20px', fontSize: '14px', fontWeight: '400' }}
        label={isAllChecked ? 'Uncheck All' : 'Check All'}
      />
    </div>
  );
  var courseTypesPerRow = 3;
  for (var k = 0; k < courses.length; k += courseTypesPerRow) {
    displayCourses.push(
      <div key={'displayCourse' + k} className="d-flex flex-row justify-content-between mb-2">
        {courses.slice(k, k + courseTypesPerRow)}
      </div>
    );
  }
  return <>{displayCourses}</>;
}

DisplayCourses.propTypes = {
  profileData: PropTypes.array,
  profileCategoriesData: PropTypes.object,
  setDisplayCourseCategories: PropTypes.func
};

export function ProfileCategories(props) {
  var categoryRows = [];
  var categorySections = [];

  for (var i = 0; i < props?.profileCategories?.length; i++) {
    categorySections.push(
      <div
        key={'profileCategorySection' + i}
        className="d-flex flex-column w-100 mx-3"
        style={{
          background: '#E7EDFF4d',
          borderRadius: '12px',
          padding: '30px',
          maxWidth: '625px'
        }}>
        {props?.profileCategories[i]}
      </div>
    );
  }

  var categoriesPerRow = 3;
  for (var j = 0; j < categorySections.length; j += categoriesPerRow) {
    categoryRows.push(
      <div key={'profileCategoryRow' + j} className="d-flex flex-row justify-content-between mb-2">
        {categorySections.slice(j, j + categoriesPerRow)}
      </div>
    );
  }

  return <>{categoryRows}</>;
}

function MyProfile() {
  const [
    triggerGetProfileInformation,
    {
      data: profileData,
      currentData: originalProfileData,
      isSuccess: profileDataSuccess,
      isFetching: isFetchingProfileData,
    }
  ] = useLazyGetProfileInformationQuery();
  

  const {
    data: profileCategoriesData,
    currentData: originalCategoriesData,
    isSuccess: profileCategoriesSuccess,
    isFetching: isFetchingProfileCategories,
    refetch: refetchProfileCategories
  } = useGetProfileCategoriesQuery();

  const [updateProfile, { profileIsSaving }] = useUpdateProfileInformationMutation();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();

  const [userSalutationId, setUserSalutationId] = useState(0);
  const userEnableNotificationRef = useRef();
  const [userDetails, setUserDetails] = useState({});
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [passwordValid, setPasswordValid] = useState(false);
  const [passwordLengthValid, setPasswordLengthValid] = useState(false);
  const [passwordCharactersValid, setPasswordCharactersValid] = useState(false);
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showNewPasswordConfirm, setShowNewPasswordConfirm] = useState(false);
  const passwordRef = useRef();
  const [otherPosition, setOtherPosition] = useState('');
  const [otherCourse, setOtherCourse] = useState('');
  const [profileCategories, setProfileCategories] = useState([]);
  const [displayCourseCategories, setDisplayCourseCategories] = useState([]);
  const [emailSubscriptions, setEmailSubscriptions] = useState([]);
  const [emailAccordionActiveKey, setEmailAccordionActiveKey] = useState('');
  const [profileCategoriesAccordionActiveKey, setProfileCategoriesAccordionActiveKey] =
    useState('');
  const [advancedAcordionActiveKey, setAdvancedAcordionActiveKey] = useState('');
  const [formValidation, setFormValidation] = useState({
    firstNameValid: true,
    lastNameValid: true,
    primaryEmailValid: true,
    secondaryEmailValid: true,
    otherPositionValid: true,
    otherContentValid: true
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [unlinkGoogleClassroom] = useUnlinkGoogleClassroomMutation();

  const profileCategoryCheckboxes = [
    <UserPositionDetailsPage
      key="positionCategories"
      profileData={profileCategories}
      categoryData={originalCategoriesData?.positionCategories}
      setProfileCategories={setProfileCategories}
      otherOptionValue={otherPosition}
      setOtherValue={setOtherPosition}
      title={'Position'}
      isMyProfilePage={true}
    />,
    <UserPositionDetailsPage
      key="gradeCategories"
      profileData={profileCategories}
      categoryData={originalCategoriesData?.gradeLevelCategories}
      setProfileCategories={setProfileCategories}
      title={'Check all applicable grade ranges you teach/support'}
      isMyProfilePage={true}
    />,
    <UserPositionDetailsPage
      key="courseCategories"
      profileData={profileCategories}
      categoryData={originalCategoriesData?.courseCategories}
      setProfileCategories={setProfileCategories}
      otherOptionValue={otherCourse}
      setOtherValue={setOtherCourse}
      title={'Choose all content you teach/support/direct '}
      isMyProfilePage={true}
    />
  ];

  React.useEffect(() => {
    triggerGetProfileInformation();
  }, []);

  const handleEmailSubscriptionsChange = (categoryId) => {
    const updatedSubscriptions = [...emailSubscriptions];
    const index = updatedSubscriptions.indexOf(categoryId);
    if (index === -1) {
      updatedSubscriptions.push(categoryId);
    } else {
      updatedSubscriptions.splice(index, 1);
    }
    setEmailSubscriptions(updatedSubscriptions);
  };

  async function handleProfileSubmit(e) {
    e.preventDefault();
    if (
      e.currentTarget.checkValidity() === false ||
      (newPassword.length > 0 &&
        (!passwordValid || !passwordLengthValid || !passwordCharactersValid || !passwordsMatch))
    ) {
      setFormValidation({
        firstNameValid: document.getElementById('firstName').validity.valid,
        lastNameValid: document.getElementById('lastName').validity.valid,
        primaryEmailValid: document.getElementById('primaryEmail').validity.valid,
        secondaryEmailValid: document.getElementById('secondaryEmail').validity.valid,
        otherPositionValid: document.getElementById('PositionTextBoxCategory_5')?.validity.valid,
        otherContentValid: document.getElementById(
          'ChooseallcontentyouteachsupportdirectTextBoxCategory_37'
        )?.validity.valid
      });

      if (
        !document.getElementById('primaryEmail').validity.valid ||
        !document.getElementById('secondaryEmail').validity.valid
      ) {
        setEmailAccordionActiveKey('0');
      }

      if (
        !document.getElementById('ChooseallcontentyouteachsupportdirectTextBoxCategory_37')
          ?.validity.valid ||
        !document.getElementById('PositionTextBoxCategory_5')?.validity.valid
      ) {
        setAdvancedAcordionActiveKey('0');
        setProfileCategoriesAccordionActiveKey('0');
      }
      e.currentTarget.reportValidity();
      return;
    } else {
      if(displayCourseCategories.length==0)
      {
        CustomToast('You must select atleast one course.', 'error');
        return;
      }
      setIsLoading(true);
      setFormValidation({
        firstNameValid: true,
        lastNameValid: true,
        primaryEmailValid: true,
        secondaryEmailValid: true,
        otherPositionValid: true,
        otherContentValid: true
      });

      setError('');
      const formData = new FormData();
      formData.append('primaryEmail', userDetails.primaryEmail);
      formData.append('secondaryEmail',userDetails.secondaryEmail);
      formData.append('otherPosition', otherPosition);
      formData.append('otherCourse', otherCourse);
      formData.append('salutationId', userSalutationId);
      formData.append('firstName', userDetails.firstName);
      formData.append('lastName', userDetails.lastName);
      formData.append('enableNotifications', userDetails.enableNotifications);
      formData.append('Password', passwordRef.current.value);
      formData.append('Image', selectedFile);
      formData.append('NewPassword', newPassword);
      
      if (uploadedImageUrl) {
        formData.append('ProfileImageURl', uploadedImageUrl);
      }

      displayCourseCategories.forEach((courseId, index) => {
        formData.append(`courses[${index}]`, courseId);
      });

      emailSubscriptions.forEach((emailSubscription, index) => {
        formData.append(`subscribedEmailCategories[${index}]`, emailSubscription);
      });

      profileCategories.forEach((profileCategory, index) => {
        formData.append(`profileCategories[${index}]`, profileCategory);
      });
      try {
        await updateProfile(formData).unwrap();
        CustomToast('Profile data saved successfully.', 'success');
        setNewPasswordConfirm('');
        setNewPassword('');
        if (passwordRef.current) {
          passwordRef.current.value = '';
        }
      } catch (ex) {
        console.log(ex);

        if (!ex?.status || ex.status === 'FETCH_ERROR') {
          setError('No server response');
        } else {
          setError('Something went wrong, could not update profile information');
        }
      }
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (originalProfileData) {
      setUploadedImageUrl(originalProfileData?.profileImageURl);
      setUserSalutationId(originalProfileData?.salutationId);
      
      setEmailSubscriptions(originalProfileData.subscribedEmailCategories);
      console.log('initial', originalProfileData.subscribedEmailCategories);
      setDisplayCourseCategories(originalProfileData.courses);
      setProfileCategories(originalProfileData?.profileCategories);
      setOtherPosition(originalProfileData.otherPosition);
      setOtherCourse(originalProfileData.otherCourse);

      setUserDetails({
        firstName:originalProfileData.firstName ?? ' ',
        lastName:originalProfileData.lastName ?? ' ',
        primaryEmail: originalProfileData.primaryEmail
          ? originalProfileData.primaryEmail
          : ' ',
        secondaryEmail:originalProfileData.secondaryEmail
          ? originalProfileData.secondaryEmail
          : ' ',
        enableNotifications:originalProfileData.enableNotifications
      });
      setIsLoading(false);
    }
  }, [originalProfileData]);

  const handleResetProfile = () => {
    setUploadedImageUrl(originalProfileData?.profileImageURl);
    setUserSalutationId(originalProfileData?.salutationId);

    setUserDetails({
      firstName:originalProfileData.firstName ?? ' ',
      lastName:originalProfileData.lastName ?? ' ',
      primaryEmail: originalProfileData.primaryEmail
        ? originalProfileData.primaryEmail
        : ' ',
      secondaryEmail:originalProfileData.secondaryEmail
        ? originalProfileData.secondaryEmail
        : ' ',
      enableNotifications:originalProfileData.enableNotifications
    });

    setEmailSubscriptions(originalProfileData.subscribedEmailCategories);
    setDisplayCourseCategories(originalProfileData.courses);
    setProfileCategories(originalProfileData?.profileCategories);
    if(originalProfileData?.otherPosition)
      setOtherPosition(originalProfileData?.otherPosition);
    if(originalProfileData.otherCourse)
      setOtherCourse(originalProfileData.otherCourse);
    setNewPasswordConfirm('');
    setNewPassword('');
  };

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
    setPasswordValid(
      e.target.value == profileData.primaryEmail ||
        e.target.value.length == 0 ||
        e.target.value == profileData.loginId
        ? false
        : true
    );
    setPasswordLengthValid(e.target.value.length < 4 ? false : true);
    setPasswordCharactersValid(
      e.target.value.match('[",\'</]') || e.target.value.length == 0 ? false : true
    );
    setPasswordsMatch(
      newPasswordConfirm && newPasswordConfirm.length > 0 && newPasswordConfirm != e.target.value
        ? false
        : true
    );
  };

  const handleConfirmPasswordBlur = (changedPassword) => {
    setPasswordsMatch(
      newPassword && newPassword.length > 0 && newPassword != changedPassword ? false : true
    );
    setNewPasswordConfirm(changedPassword);
  };

  const navigate = useNavigate();
  const navigateToDashboard = (e) => {
    navigate(-1);
  };

  const unlinkGoogleClassroomClick = async (e) => {
    const response = await unlinkGoogleClassroom().unwrap();
    CustomToast(response.message, 'success');
  };

  const forgotPasswordClick = async (e) => {
    window.location.href = 'https://cl.castlelearning.com/Review/CLO/Account/Forgot';
  };

  const handleFileSelect = (file) => {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
    const maxSize = 3 * 1024 * 1024; // 3MB

    if (allowedTypes.includes(file.type) && file.size <= maxSize) {
      setSelectedFile(file);
      setUploadedImageUrl(file ? URL.createObjectURL(file) : null);
    } else {
      CustomToast('Invalid file. Please upload a JPG, GIF, or PNG file (max 3MB).', 'warning');
      setUploadedImageUrl(null);
    }
  };
  const handleRemove = () => {
    setSelectedFile(null);
    setUploadedImageUrl(null);
  };

  return (
    <>
      {isLoading  ? (
        <>
          <div className='myProfileCard'>
            <Row>
              <div className='col-6'>
                <div className='align-items-center d-flex gap-4'>
                  <Skeleton circle width={90} height={90} />
                  <div className='w-100'>
                    <SkeletonGrid
                      colCount={1}
                      rowCount={1}
                      className='p-1' />
                  </div>
                </div>
              </div>
              <div className='col-6'>
                <SkeletonGrid
                  colCount={1}
                  rowCount={3}/>
              </div>
            </Row>
            <SkeletonGrid
              colCount={3}
              rowCount={1}
              className='p-3 mt-4'/>
          </div>
          <div className='myProfileCard mt-4'>
            <SkeletonGrid
              colCount={1}
              rowCount={3}
              className='p-1 mt-3'/>
            <div className='col-6'>
              <SkeletonGrid
                colCount={2}
                rowCount={1}
                className='p-3 mt-4'/>
            </div>
            <SkeletonGrid
              colCount={1}
              rowCount={1}
              className='p-1 mt-3'/>
          </div>
          <div className='myProfileCard mt-4'>
            <SkeletonGrid
              colCount={1}
              rowCount={1}
              className='p-2'/>
          </div>
          <div className='myProfileCard mt-4'>
            <SkeletonGrid
              colCount={1}
              rowCount={1}
              className='p-2'/>
          </div>
          <div className='myProfileCard mt-4 d-flex gap-4'>
            <div className='col-9'>
              <SkeletonGrid
                colCount={2}
                rowCount={1}
                className='p-2'/>
            </div>
            <div className='col-3'>
              <SkeletonGrid
                colCount={3}
                rowCount={1}
                className='p-2'/>
            </div>
          </div>
        </>
      ):
        (
          <Form noValidate onSubmit={handleProfileSubmit}>
            <div className="d-flex flex-column">
              <div className="d-flex flex-column mb-4 myProfileCard">
                <h1>My Profile</h1>
                <div className="d-flex flex-row my-3 profileNameImage">
                  <div className="d-flex flex-row justify-content-between align-items-center w-100">
                    <div className="d-flex flex-row align-items-center mx-3 w-100">
                      <div className="profileInitials">
                        <div style={{ verticalAlign: 'middle' }}>{`${originalProfileData?.firstName
                          .slice(0, 1)
                          .toUpperCase()}${originalProfileData?.lastName
                          .slice(0, 1)
                          .toUpperCase()}`}</div>
                      </div>
                      <div>
                        <span style={{ fontSize: '16px', fontWeight: '600' }}>{`${
                          profileCategoriesData?.salutationOptions[originalProfileData?.salutationId]
                        } ${originalProfileData?.firstName} ${originalProfileData?.lastName}`}</span>
                        <br />
                        {profileCategoriesData?.positionCategories
                          .filter((s) => profileData?.profileCategories?.includes(s.categoryId))
                          .map(function (position) {
                            return position.categoryOption;
                          })
                          .join(', ')}
                      </div>
                    </div>
                    <div style={{ border: '1px solid #E7EDFF' }} className="h-75"></div>
                    <div className="d-flex flex-row align-items-center mx-3 w-100">
                      <div className="fw-light text-end w-100">
                        <ImageUpload onFileSelect={handleFileSelect} selectedFile={selectedFile} />
                      </div>
                      {uploadedImageUrl && (
                        <div className="mx-1">
                          <div>
                            <img
                              style={{ width: '100px', height: '95px' }}
                              src={uploadedImageUrl}></img>
                          </div>
                          <div className="py-1">
                            <Button
                              className="btn btn-castleWhite w-100 p-0"
                              style={{ height: '24px' }}
                              onClick={handleRemove}>
                              <FontAwesomeIcon className="me-2" icon={faTrashAlt} />
                          Remove
                            </Button>
                          </div>
                        </div>
                      )}
                      {!uploadedImageUrl && (
                        <div className="uploadImage">
                          <FontAwesomeIcon
                            icon={faUpload}
                            color="#A0B1DE"
                            transform="grow-10"
                            fixedWidth
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-row">
                  <Form.Group
                    controlId="salutation"
                    style={{ minWidth: '100px', maxWidth: '215px', width: '100%' }}>
                    <Form.Label>Salutation</Form.Label>
                    <Form.Select
                      id="salutationSelect"
                      onChange={(e) => setUserSalutationId(e.target.value)}
                      value={userSalutationId}>
                      {profileCategoriesData?.salutationOptions.map((salutationOption, index) => {
                        return (
                          <option value={index} key={'salutation_' + index}>
                            {salutationOption}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group
                    controlId="firstName"
                    className="mx-2"
                    style={{ minWidth: '100px', maxWidth: '450px', width: '100%' }}>
                    <Form.Label>* First Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={userDetails.firstName}
                      onChange={(e) => setUserDetails(prev => ({...prev, firstName: e.target.value}))}
                      isInvalid={!formValidation.firstNameValid}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                  Please provide a first name
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group
                    controlId="lastName"
                    style={{ minWidth: '100px', maxWidth: '450px', width: '100%' }}>
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={userDetails.lastName}
                      onChange={(e) => setUserDetails(prev => ({...prev, lastName: e.target.value}))}
                      isInvalid={!formValidation.lastNameValid}
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                  Please provide a last name
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </div>

              <div className="d-flex flex-column mb-4 myProfileCard">
                <h1>Change Password</h1>
                <div className="d-flex flex-row">
                  <div className="col-10">
                    <p>
                  You must know your current password in order to change your password on this
                  screen.
                    </p>
                    <p>
                  If you do not know your current password, you may request a password reset email
                  by clicking on this{' '}
                      <a
                        href="https://cl.castlelearning.com/Review/CLO/Account/Forgot"
                        target="_blank"
                        rel="noreferrer">
                    link
                      </a>
                  .
                    </p>
                    <p>
                  The reset email may be sent to either the primary or secondary email you have
                  listed in the Email Address section below
                    </p>
                  </div>
                  <div className="align-self-center col-2">
                    <Button onClick={forgotPasswordClick} variant="castleWhite">
                  Forgot Password
                    </Button>
                  </div>
                </div>
                <div className="mb-3" style={{ border: '1px solid #E7EDFF', width: '100%' }}></div>

                <div className="d-flex flex-row">
                  <Form.Group
                    className="me-2"
                    id="newPassword"
                    style={{ minWidth: '100px', maxWidth: '450px', width: '100%' }}>
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                      onChange={handleNewPasswordChange}
                      value={newPassword}
                      type={showNewPassword ? 'text' : 'password'}
                    />
                    <FontAwesomeIcon
                      className="passwordShowHideIcon"
                      style={{ cursor: 'pointer' }}
                      icon={showNewPassword ? faEyeSlash : faEye}
                      onClick={() => setShowNewPassword(!showNewPassword)}
                    />
                  </Form.Group>

                  <Form.Group
                    id="confirmNewPassword"
                    style={{ minWidth: '100px', maxWidth: '450px', width: '100%' }}>
                    <Form.Label>Re-type your new password</Form.Label>
                    <Form.Control
                      onChange={(e) => handleConfirmPasswordBlur(e.target.value)}
                      value={newPasswordConfirm}
                      type={showNewPasswordConfirm ? 'text' : 'password'}
                    />
                    <FontAwesomeIcon
                      className="passwordShowHideIcon"
                      style={{ cursor: 'pointer' }}
                      icon={showNewPasswordConfirm ? faEyeSlash : faEye}
                      onClick={() => setShowNewPasswordConfirm(!showNewPasswordConfirm)}
                    />
                    {passwordsMatch ? null : <div className="text-danger">Passwords do not match</div>}
                  </Form.Group>
                </div>
                <div className="d-flex flex-row mt-3">
                  <div>
                    <FontAwesomeIcon
                      style={{ marginRight: '7px' }}
                      icon={
                        newPassword.length > 0
                          ? passwordLengthValid
                            ? faCircleCheck
                            : faCircleXmark
                          : faCircle
                      }
                      color={
                        newPassword.length > 0
                          ? passwordLengthValid
                            ? '#52C9A5'
                            : '#F84646'
                          : '#000000'
                      }
                    />
                    <span>Must Be At Least 4 Characters In Length</span>
                  </div>
                  <div className="mx-3">
                    <FontAwesomeIcon
                      style={{ marginRight: '7px' }}
                      icon={
                        newPassword.length > 0
                          ? passwordValid
                            ? faCircleCheck
                            : faCircleXmark
                          : faCircle
                      }
                      color={
                        newPassword.length > 0 ? (passwordValid ? '#52C9A5' : '#F84646') : '#000000'
                      }
                    />
                    <span>Cannot Be The Same As Your Login ID</span>
                  </div>
                  <div>
                    <FontAwesomeIcon
                      style={{ marginRight: '7px' }}
                      icon={
                        newPassword.length > 0
                          ? passwordCharactersValid
                            ? faCircleCheck
                            : faCircleXmark
                          : faCircle
                      }
                      color={
                        newPassword.length > 0
                          ? passwordCharactersValid
                            ? '#52C9A5'
                            : '#F84646'
                          : '#000000'
                      }
                    />
                    <span>{'Cannot Include The Following Special Characters (",\'</)'}</span>
                  </div>
                </div>
              </div>

              <Accordion
                className="d-flex flex-row mb-4"
                id="emailAccordion"
                activeKey={emailAccordionActiveKey}
                onSelect={(e) => setEmailAccordionActiveKey(e)}>
                <Accordion.Item className="w-100" eventKey="0">
                  <Accordion.Header>
                    <h1 style={{ margin: '0px' }}>
                  Email Address as Alternate Login and to Get Forgotten ID and Password
                    </h1>
                  </Accordion.Header>
                  <Accordion.Body className="d-flex flex-row">
                    <div className="d-flex flex-column w-100">
                      <p>
                    If you forget your Login ID and/or your password, you can click the Forgot your
                    ID or Password link on the Sign-In page and have these emailed to you. To enable
                    this, please enter your email address.
                      </p>
                      <Form.Group
                        id="primaryEmailAddress"
                        style={{ minWidth: '100px', maxWidth: '450px', width: '100%' }}>
                        <Form.Label>Primary Email Address</Form.Label>
                        <Form.Control
                          id="primaryEmail"
                          value={userDetails.primaryEmail}
                          onChange={(e) => setUserDetails(prev => ({...prev, primaryEmail: e.target.value}))}
                          isInvalid={!formValidation.primaryEmailValid}
                          required
                          type="email"
                        />
                        <Form.Control.Feedback type="invalid">
                          {userDetails.primaryEmail
                            ? 'Please provide a valid primary email address'
                            : 'Please provide a primary email address'}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <div className="d-flex flex-row align-items-center mt-3">
                        <FontAwesomeIcon
                          size="2x"
                          className="me-2"
                          color="#63D0FF"
                          icon={faCircleInfo}
                        />
                        <div>
                      When setting this email, students and teachers will be able to use this as an
                      alternate login id.
                        </div>
                      </div>
                    </div>
                    <div className="mx-5" style={{ border: '1px solid #E7EDFF' }}></div>

                    <div className="d-flex flex-column w-100">
                      <p>
                    You can also provide a secondary email address to be used for password reset
                    purposes only (you will not be able to login using this email, but can use it to
                    reset your password)
                      </p>
                      <Form.Group
                        id="secondaryEmailAddress"
                        style={{ minWidth: '100px', maxWidth: '450px', width: '100%' }}>
                        <Form.Label>Secondary Email Address</Form.Label>
                        <Form.Control
                          id="secondaryEmail"
                          value={userDetails.secondaryEmail}
                          onChange={(e) => setUserDetails(prev => ({...prev, secondaryEmail: e.target.value}))}
                          isInvalid={!formValidation.secondaryEmailValid}
                          type="email"
                        />
                        <Form.Control.Feedback type="invalid">
                      Secondary email is not a valid email address
                        </Form.Control.Feedback>
                      </Form.Group>

                      <div className="d-flex flex-row align-items-center mt-3">
                        <FontAwesomeIcon
                          size="2x"
                          className="me-3"
                          color="#63D0FF"
                          icon={faCircleInfo}
                        />
                        <span>
                      The secondary email (as well as your primary email) is used if you have
                      forgotten your login id or password and need to use the Forgot your ID or
                      Password link.
                        </span>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <Accordion
                className="d-flex flex-row mb-4"
                activeKey={advancedAcordionActiveKey}
                onSelect={(e) => setAdvancedAcordionActiveKey(e)}>
                <Accordion.Item className="w-100" eventKey="0">
                  <Accordion.Header>
                    <h1 style={{ margin: '0px' }}>Advanced Settings</h1>
                  </Accordion.Header>
                  <Accordion.Body className="d-flex flex-column">
                    <div className="d-flex flex-row">
                      <div className="d-flex flex-column w-100">
                        <Form.Check
                          style={{ marginBottom: '15px' }}
                          id="enabledNotification"
                          key="enabledNotification"
                          name="enabledNotification"
                          type="checkbox"
                          checked={userDetails.enableNotifications}
                          onChange={(e) => setUserDetails(prev => ({...prev, enableNotifications: e.target.checked}))}
                          label="Enable Notifications"
                        />
                        <p>
                      This controls enabling/disabling all notifications for all devices. To
                      manually turn off notifications on a single device or browser use the settings
                      appropriate to the device or browser.
                        </p>
                      </div>
                      <div className="mx-5" style={{ border: '1px solid #E7EDFF' }}></div>
                      <div className="d-flex flex-column w-100">
                        <Button
                          onClick={unlinkGoogleClassroomClick}
                          style={{ maxWidth: '220px', marginBottom: '15px' }}
                          variant="castleWhite">
                      Unlink Google Classroom
                        </Button>
                        <p>
                      If you accidentally connected the wrong Google email or have changed your
                      email and need to reset it with Google Classroom please click this link.
                        </p>
                      </div>
                    </div>

                    <Accordion
                      className="d-flex flex-row mt-4 profileNameImage"
                      style={{ padding: '5px' }}>
                      <Accordion.Item className="w-100" eventKey="0">
                        <Accordion.Header>
                          <h1 style={{ margin: '0px' }}>Select Courses</h1>
                        </Accordion.Header>
                        <Accordion.Body className="d-flex flex-column">
                          <p>
                        Select the courses you would like displayed throughout the site. Having
                        trouble finding questions? Try adding all the courses in this area.
                          </p>
                          {profileCategoriesSuccess && profileDataSuccess && (
                            <DisplayCourses
                              profileCategoriesData={profileCategoriesData}
                              profileData={displayCourseCategories}
                              setDisplayCourseCategories={setDisplayCourseCategories}
                            />
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>

                    <Accordion
                      className="d-flex flex-row mt-4 profileNameImage"
                      style={{ padding: '5px' }}
                      activeKey={profileCategoriesAccordionActiveKey}
                      onSelect={(e) => setProfileCategoriesAccordionActiveKey(e)}>
                      <Accordion.Item className="w-100" eventKey="0">
                        <Accordion.Header>
                          <h1 style={{ margin: '0px' }}>Select Profile Categories</h1>
                        </Accordion.Header>
                        <Accordion.Body className="d-flex flex-column">
                          <p>
                        To provide you with the most current information associated with your
                        position, please complete the following profile survey.
                            <p>
                          The information you provide will help us send you updated information just
                          for your grade level and content.{' '}
                            </p>
                          </p>
                          <p>
                        We do not give out your information to any third parties. Please review our{' '}
                            <a
                              href="/Documents/Castle-Learning-Data-Privacy-Security-Policy-2022.pdf"
                              target="_blank">
                          Privacy Policy
                            </a>
                        .
                          </p>
                          {originalCategoriesData &&
                      <ProfileCategories profileCategories={profileCategoryCheckboxes} />
                          }
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>

                    <Accordion
                      className="d-flex flex-row mt-4 profileNameImage"
                      style={{ padding: '5px' }}>
                      <Accordion.Item className="w-100" eventKey="0">
                        <Accordion.Header>
                          <h1 style={{ margin: '0px' }}>Manage Email Subscriptions</h1>
                        </Accordion.Header>
                        <Accordion.Body className="d-flex flex-column">
                          <p>
                        To stop receiving emails of one specific type, uncheck the appropriate box
                        and click Save below. You may uncheck all boxes and you will receive only
                        emails specifically related to changes to your account.
                          </p>

                          {profileCategoriesData?.emailSubscriptionCategories.map(
                            (emailCategory, index) => {
                              return (
                                <Form.Check
                                  id={'emailSubscription_' + emailCategory.emailSubscription.categoryId}
                                  key={'emailSub' + index}
                                  style={{ fontSize: '14px', fontWeight: '400' }}>
                                  <Form.Check.Input
                                    type="checkbox"
                                    checked={emailSubscriptions.includes(
                                      emailCategory.emailSubscription.categoryId
                                    )}
                                    onChange={() =>
                                      handleEmailSubscriptionsChange(
                                        emailCategory.emailSubscription.categoryId
                                      )
                                    }
                                  />
                                  <Form.Check.Label className="d-flex flex-row">
                                    <p style={{ fontWeight: '600', marginRight: '0.5em' }}>
                                  &nbsp;{emailCategory.emailSubscription.categoryOption}
                                    </p>
                                    <p>{emailCategory.description}</p>
                                  </Form.Check.Label>
                                </Form.Check>
                              );
                            }
                          )}
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <div className="d-flex flex-row justify-content-between mb-4 saveChanges">
                <div className="d-flex flex-row w-100 align-items-center">
                  <span className="me-2">
                To make any changes, you must enter your current password:
                  </span>
                  <Form.Group
                    className="me-2 w-100"
                    id="newPassword"
                    style={{ minWidth: '100px', maxWidth: '450px', width: '100%' }}>
                    <Form.Control ref={passwordRef} type="password" placeholder="Password" required />
                  </Form.Group>

                  {error && <div style={{ color: '#F84646', mnarginLeft: '10px' }}>{error}</div>}
                </div>

                <div className="d-flex flex-row justify-content-evenly align-items-center w-25 gap-2">
                  <Button
                    className="w-100"
                    onClick={navigateToDashboard}
                    style={{ maxWidth: '110px' }}
                    variant="castleGray">
                Cancel
                  </Button>
                  <Button
                    className="w-100"
                    style={{ maxWidth: '110px' }}
                    variant="castleWhite"
                    onClick={handleResetProfile}>
                Reset
                  </Button>
                  <Button
                    className="w-100"
                    style={{ maxWidth: '110px' }}
                    variant="castleRed"
                    type="submit"
                    disabled={profileIsSaving}>
                Save
                  </Button>
                </div>
              </div>

              <div className="d-flex flex-column">
                <p style={{ fontWeight: '600' }}>Privacy statement:</p>
                <p>
              Email addresses are considered to be extremely private and will not be given out or
              sold to other companies. We request Email addresses in order to be able to email to
              users a forgotten ID or password or for special Castle Learning features.
                </p>
              </div>
            </div>
          </Form>
        )}
      
    </>
  );
}

export default MyProfile;
